module.exports = __webpack_public_path__ + "images/state-heroes/desktop/CA.webp";